import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import BASE_URL from "../../../../config/config";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import JobAssetService from "../../Controller/JobAssetController";
import useDateFormat from '../../../Common/fetchDateFormat';
function CreateJobDocument({ AssetID, onClose, JobID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    const [jobList, setJobList] = useState([]);
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const activeDateFormat = useDateFormat();
    useEffect(() => {
        fetchJobsByAsset(AssetID);
    }, [AssetID]);

    const fetchJobsByAsset = async (assetID) => {
        try {
         
            let JobList = await JobAssetService.GetIssueByAssetID(assetID);
            JobList = JobList.filter(x => x.IssueID != null && x.IssueID != JobID);
            setJobList(JobList);
        }
        catch (error) {
            alert(error);
        }
    };




    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>

            <div className="modal fade assetJobModal show d-block" id="assetJobModal" tabIndex="-1" aria-labelledby="assetJobModalLabel" aria-hidden="true" data-backdrop="static">

                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Asset Detail</h5>
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto" }}>
                                <div className="table-responsive">
                                    <div className='divTable'>

                                        <div style={{ maxHeight: "460px", overflow: "auto" }}>
                                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Job No.</th>
                                                        <th>Customer</th>
                                                        <th>Priority</th>
                                                        <th>Cateogry</th>
                                                        <th>Description</th>
                                                        <th>Due Date</th>
                                                        <th>Assigned To</th>
                                                        <th>Status</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {jobList.map((job) => (
                                                        <tr key={job.IssueID} >
                                                            <td className="no-wrap" title={job.bnt_OrderNumber}>{job.bnt_OrderNumber}</td>
                                                            <td className="no-wrap" title={job.CompanyName}>{job.CompanyName}</td>
                                                            <td className="no-wrap">

                                                                {job.Icon ? (
                                                                    job.Icon.includes('Default/SuperAdmin') ? (
                                                                        <img
                                                                            src={`${BASE_URL}/${job.Icon}`}

                                                                        />
                                                                    ) : (
                                                                        <img src={`${BASE_URL}/uploads/${CompanyID}/Setup/Priority/${job.Icon}`} alt="Icon" />
                                                                    )
                                                                ) : (
                                                                    <img
                                                                        src={`${BASE_URL}/uploads/default-icon.png`}

                                                                    />
                                                                )}



                                                            </td>
                                                            <td className="no-wrap" title={job.CategoryName}>
                                                                {job.CategoryName}
                                                            </td>
                                                            <td className="no-wrap" title={job.IssueTitle}>
                                                                {job.IssueTitle}
                                                            </td>
                                                            <td className="no-wrap">

                                                                {formatDateWithFns(job.TimeToCall, activeDateFormat)}
                                                            </td>
                                                            <td className="no-wrap" title={job.AssignedTo}>

                                                                {job.AssignedTo}

                                                            </td>
                                                            <td className="no-wrap">

                                                                {job.IsIcon ? (
                                                                    job.IsIcon.includes('Default/SuperAdmin') ? (
                                                                        <img
                                                                            src={`${BASE_URL}/${job.IsIcon}`}

                                                                        />
                                                                    ) : (
                                                                        <img src={`${BASE_URL}/uploads/${CompanyID}/Setup/Status/${job.IsIcon}`} alt="Icon" />
                                                                    )
                                                                ) : (
                                                                    <img
                                                                        src={`${BASE_URL}/uploads/default-icon.png`}

                                                                    />
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </div>

        </div>
    );
}

export default CreateJobDocument;
